import clsx from 'clsx';
import PropTypes from 'prop-types';

export default function Heading({ children, className }) {
  return (
    <h1
      className={clsx(
        'text-corporate-light tracking-wide-header leading-wide-header font-wide text-[1.3rem] font-medium',
        className,
      )}
    >
      {children}
    </h1>
  );
}

Heading.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};
